import React from 'react';
import PropTypes from 'prop-types';
import './SingleBlog.scss';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const SingleBlog = () => {

  const location = useLocation();
  
  const blogData = location.state?.blogData;

   const canonicalUrl = "https://whitetowerinternational.com/SingleBlog/:id";

  return (
    <div className="SingleBlog">
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>White Tower - Single Blog</title>
      </Helmet>
        <section className="blog-section-1">
          <div className="inner-blog-section-1">
            <div className="container">
              <div className="blog-section-1-head">
                <h1>BLOG</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="inner-single-blog-section">
            <div className="single-blog-container">
              <img className='main-blog-image max-h-[400px] object-cover w-full' src={blogData?.image} alt="" />
              <div className="actual-title-section mt-10 mb-4">
                <h4 className='text-2xl font-semibold text-black'>{blogData?.actualTitle}</h4>
              </div>
              <div className="main-para">
                <p className=''>{blogData?.mainPara}</p>
              </div>
              <div className="outer-single-listers-section-blogger flex flex-col gap-8 mt-4">
                {blogData?.contentBinding?.map((items , index) => {
                  return (
                    <div className="single-list-content-para-indies" key={index}>
                      <div className="subheading-blog flex flex-col gap-2">
                        <h4 className='text-xl font-medium text-black'>{items?.subHead}</h4>
                        <p>{items?.subContent}</p>
                      </div>
                      <div className="list-blog-section">
                        <h4>{items?.listHead}</h4>
                        <div className="inner-list-blogger mt-4">
                            {items?.listContent ? 
                                <ul className='flex flex-col gap-3'>
                                {items?.listContent?.map((listItems , listIndex) => {
                                  return (
                                    <li key={listIndex}><strong>{listItems?.strongTag}</strong><p>{listItems?.listText}</p></li>
                                  )
                                })}
                              </ul> : null
                            }
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
        </section>
    </div>
  );
}

SingleBlog.propTypes = {};

SingleBlog.defaultProps = {};

export default SingleBlog;
